
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/valor-de-mi-auto/[slug]",
      function () {
        return require("private-next-pages/valor-de-mi-auto/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/valor-de-mi-auto/[slug]"])
      });
    }
  